import React from "react";
import Popup from "reactjs-popup";
import LoadingOverlay from "react-loading-overlay";
import { branchMasterApiConfig } from "../config/apiConfig.js";
import { USE_OVERLAY } from "../config/config.js";
import {
  branchMasterGroupInfo,
  branchMasterDataObject,
  branchMasterValidate,
} from "../config/branchMasterForm";
import "./Form.css";
import "./ChallanForm.css";
import "./AutoSuggest.css";
import useForm from "./useForm";
import "./popup.css";
import "../components/ItemMasterForm.css";

const BranchMaster = ({ sessionObject }) => {
  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  let variablesFromSession = {
    station_from: String(sessionObject.sessionVariables.branch_id),
    station_from_name: sessionObject.sessionVariables.branch_name,
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
  };

  const myForm = useForm(
    "BranchMaster",
    branchMasterValidate,
    { ...branchMasterDataObject, ...variablesFromSession },
    branchMasterApiConfig
  );

  return (
    <div className="item-master-form-container">
      {USE_OVERLAY && (
        <LoadingOverlay
          active={myForm.submitApiState.loading}
          spinner
          text="Saving Branch..."
          styles={{
            wrapper: {
              overflow: "hidden",
            },
          }}
        ></LoadingOverlay>
      )}
      <div>
        <Popup
          open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {" "}
                {myForm.pageMode == "submitted" ? (
                  <div>Saving Successful </div>
                ) : (
                  <div>Error In Branch Master Module </div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              {myForm.pageMode == "submitted" ? (
                <div className="pop-up-content">
                  {" "}
                  Branch is successfully saved with the following info:-
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">Branch Name</div>
                      <div className="pop-up-field-value">
                        {myForm.pageState.name}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="pop-up-content">
                  {" "}
                  Error in Branch Master module with the following info:-
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">Error:</div>
                      <div className="pop-up-field-value">
                        {myForm.popupError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    if (myForm.pageMode == "submitted") {
                      myForm.setPageState({
                        ...branchMasterDataObject,
                        ...variablesFromSession,
                      });
                      myForm.setPageMode("write");
                      window.location.reload();
                      close();
                    } else {
                      myForm.setPageMode("write");
                      close();
                    }
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
      <div className="form-header">Branch Master</div>
      <div className="form" noValidate>
        <div className="form-title">
          <div className="form-row">
            <label className="form-label">Id: {myForm.pageState.id}</label>
          </div>
        </div>

        <div className="form-input-content-block-0">
          <div className="form-field-left">
            {branchMasterGroupInfo["group-1"].map(function (info) {
              return (
                <div className={info["className"]} key={info["name"]}>
                  <label className={info["labelClassName"]}>
                    {info["label"]}
                  </label>
                  <input
                    id={info["name"]}
                    className={info["inputClassName"]}
                    type={info["type"]}
                    name={info["name"]}
                    placeholder={info["placeHolder"]}
                    value={myForm.pageState[info["name"]] || ""}
                    onChange={myForm.handleChange}
                    onBlur={() =>
                      info["toValidate"] ? myForm.onblurValidator(info) : {}
                    }
                    onKeyPress={(a) => myForm.onKeyPressForKeyNav(a, info)}
                    ref={(a) =>
                      myForm.storeInputReferenceForSelect(a, info["name"])
                    }
                  />
                  {myForm.internalValidationErrors[info["name"]] && (
                    <p>{myForm.internalValidationErrors[info["name"]]}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className="form-footer">
          <button
            onClick={myForm.handleSubmit}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default BranchMaster;
